class QuickBuyNoVariant extends HTMLElement {
  constructor () {
    super()

    this.button = this.querySelector('[data-quick-buy-btn]')
    this.buttonText = this.querySelector('[data-quick-buy-btn] span')
    this.buttonLoader = this.querySelector('.loading-overlay__spinner')
    this.cartItems = document.querySelector('cart-items')
    this.variantIds = this.getAttribute('variant-ids')

    if (!this.button) {
      return
    }

    this.button.addEventListener('click', this.addToCart.bind(this))
  }

  handleErrorMessage (errorMessage = false) {
    this.errorMessageWrapper = this.errorMessageWrapper || this.error
    this.errorMessage = this.errorMessage || this.errorMessageText
    this.errorMessageWrapper?.toggleAttribute('hidden', !errorMessage)

    if (errorMessage) {
      this.errorMessage.textContent = errorMessage
    }
  }

  addToCart (event) {
    event?.preventDefault()
    if (!this.variantIds) {
      return
    }

    this.handleErrorMessage()

    this.button?.setAttribute('aria-disabled', true)
    this.button?.classList.add('loading')
    this.buttonLoader?.classList.remove('hidden')

    const quantityEl = this.querySelector('input[name="quantity"]')
    const quantity = quantityEl ? parseInt(quantityEl.value) : 1

    let properties
    if (this.properties) {
      try {
        properties = JSON.parse(this.properties)
      } catch (err) {
        console.error(err)
      }
    }

    const itemsObj = []
    const varIdsArr = this.variantIds.split(',')

    varIdsArr.forEach(varId => {
      itemsObj.push({
        id: varId,
        quantity,
        properties,
      })
    })

    let body = {
      items: itemsObj,
    }

    if (this.cartItems) {
      body.sections = this.cartItems
        .getSectionsToRender()
        .map(section => section.id)
      body.sections_url = window.location.pathname
    }

    body = JSON.stringify(body)

    fetch(`${window.routes.cart_add_url}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: `application/json`,
      },
      body,
    })
      .then(response => response.json())
      .then(response => {
        if (response.status) {
          this.handleErrorMessage(response.description)
          return
        }

        const addToCartEvent = new CustomEvent('GA_ADD_TO_CART', {
          detail: {
            formName: 'quickBuy',
            item: response.items[0],
          },
        })
        window.dispatchEvent(addToCartEvent)

        this.cartItems?.renderContents(response)
      })
      .catch(e => {
        console.error(e)
      })
      .finally(() => {
        this.button?.classList.remove('loading')
        this.button?.removeAttribute('aria-disabled')
        this.buttonLoader?.classList.add('hidden')
      })
  }
}

customElements.define('quick-buy-no-variant', QuickBuyNoVariant)
